/**
 * Do not edit directly
 */

export default "PHN2ZyB2aWV3Qm94PSIwIDAgMTYgMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTYuNSAxMi40Mkw3LjIxIDExLjcxTDMuNzEgOC4yMUwxNCA4LjIxTDE0IDcuMjFMMy43MSA3LjIxTDcuMjEgMy43MUw2LjUgM0wxLjc5IDcuNzFMNi41IDEyLjQyWiIvPjwvc3ZnPg==";